import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Paragraph from '../../Paragraph/Paragraph';
import Modal from '../../Modal';
import ButtonPrimary from '../../Buttons/Button';
import themeColors from '../../../assets/styles/themeColors';

const ErrorModal = ({ isOpen, onClose, redirect, errorMessage }) => {
  const { t } = useTranslation();

  return (
    <Modal
      variant="md"
      isOpen={isOpen}
      onClose={onClose}
      label={t('common.error')}
    >
      <Paragraph color={themeColors.colorTextXLLight} mb={28}>
        {errorMessage}
      </Paragraph>
      <ButtonPrimary onClick={redirect} title={t('common.ok')} />
    </Modal>
  );
};

ErrorModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  redirect: PropTypes.func,
  errorMessage: PropTypes.string,
};

export default ErrorModal;
